<template>
    <div>
        <div class="field">
            <div class="control">
                <router-link class="button is-success" :to="{'name': 'branch-create'}">Create branch</router-link>
            </div>
        </div>

        <table class="table is-fullwidth">
            <tr>
            <th>Branch</th>
            <th>Name</th>
            <th>Address</th>
            <th>Description</th>
            <th>Is demo</th>
            <th>RTP Level</th>
            <th></th>
            </tr>
            <tr v-for="branch in branches" :key="branch.branch">
            <td>
                <span v-if="isPanicBranch(branch)" class="tag is-danger">PANIC!</span>
                <router-link :to="{ name: 'branch-general', params: { branch: branch.branch } }">{{branch.branch}}</router-link>
            </td>
            <td>{{branch.name}}</td>
            <td>{{branch.address}}</td>
            <td>{{branch.description}}</td>
            <td>
                <span v-if="branch.isDemo" class="tag is-warning">demo</span>
            </td>
            <td>
                <a v-if="isPanicBranch(branch)" class="button" @click="panic(branch, false)">Don't panic</a>
                <a v-else class="button is-danger" @click="panic(branch, true)">Panic</a>
            </td>
            <td>
                <span class="tag" :class="{'is-danger': branch.rtpLevel == 'veryGreedy', 'is-warning': (['slightlyGreedy', 'littleGreedy', 'greedy'].includes(branch.rtpLevel))}">{{ branch.rtpLevel || "normal" }}</span>
            </td>
            </tr>
        </table>
    </div>
</template>
<script>
  import branchService from "../../../../services/branch.service"

  export default {
    name: 'client-branch-list',
    data() {
      return {
        branches: []
      }
    },
    computed: {
      clientId() {
        return Number(this.$route.params.clientId);
      }
    },
    async mounted() {
      await this.loadBranches();
    },
    methods: {
      async loadBranches() {
        this.branches = await branchService.getByClient(this.clientId);
      },
      async panic(branch, isPanic) {
        let message = isPanic ? "Are you really panic?" : "Stop panic?";
        if (!window.confirm(message))
          return;

        branch.settings = branch.settings || {};
        branch.settings.panic = branch.settings.panic || {};
        branch.settings.panic.isPanic = isPanic;
        branch.settings = await branchService.saveSettings(this.clientId, branch.branch, branch.settings);
      },
      isPanicBranch(branch) {
        return branch.settings && branch.settings.panic && branch.settings.panic.isPanic
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/branches/list.vue